/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_End_LabelInputs */

const en_compare_event_groups_end_label = /** @type {(inputs: Compare_Event_Groups_End_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`End:`)
};

const fr_compare_event_groups_end_label = /** @type {(inputs: Compare_Event_Groups_End_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fin :`)
};

const de_compare_event_groups_end_label = /** @type {(inputs: Compare_Event_Groups_End_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ende:`)
};

const it_compare_event_groups_end_label = /** @type {(inputs: Compare_Event_Groups_End_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FINE:`)
};

const ru_compare_event_groups_end_label = /** @type {(inputs: Compare_Event_Groups_End_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Конец:`)
};

const es_compare_event_groups_end_label = /** @type {(inputs: Compare_Event_Groups_End_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fin:`)
};

const zh_cn2_compare_event_groups_end_label = /** @type {(inputs: Compare_Event_Groups_End_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`结尾：`)
};

const ja_compare_event_groups_end_label = /** @type {(inputs: Compare_Event_Groups_End_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`終わり：`)
};

const hi_compare_event_groups_end_label = /** @type {(inputs: Compare_Event_Groups_End_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अंत:`)
};

const pt_pt2_compare_event_groups_end_label = /** @type {(inputs: Compare_Event_Groups_End_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fim:`)
};

/**
* | output |
* | --- |
* | "End:" |
*
* @param {Compare_Event_Groups_End_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_end_label = /** @type {((inputs?: Compare_Event_Groups_End_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_End_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_compare_event_groups_end_label(inputs)
	if (locale === "de") return de_compare_event_groups_end_label(inputs)
	if (locale === "it") return it_compare_event_groups_end_label(inputs)
	if (locale === "ru") return ru_compare_event_groups_end_label(inputs)
	if (locale === "es") return es_compare_event_groups_end_label(inputs)
	if (locale === "zh-CN") return zh_cn2_compare_event_groups_end_label(inputs)
	if (locale === "ja") return ja_compare_event_groups_end_label(inputs)
	if (locale === "hi") return hi_compare_event_groups_end_label(inputs)
	if (locale === "pt-PT") return pt_pt2_compare_event_groups_end_label(inputs)
	return en_compare_event_groups_end_label(inputs)
});